import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupsService } from "../../services/groups.service";
import { AddStudentGroupRequest } from "./AddStudentGroupRequest";

@Component({
	selector: "app-add-student-group",
	templateUrl: "./add-student-group.component.html",
	styleUrls: ["./add-student-group.component.css", "../../groups.css"],
})
export class AddStudentGroupComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private groupService: GroupsService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	SchoolID: number = 0;
	GroupName: string = "";

	loading: boolean = false;
	errorMessage: string = "";

	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.GroupName == "") {
			this.errorMessage = "Enter a Group Name";
			return;
		}

		this.loading = true;

		let parms: AddStudentGroupRequest = {
			ApplicationItemID: "",
			GroupName: this.GroupName,
			SchoolID: this.SchoolID,
		};

		var result = this.groupService.AddStudentGroup(parms);
		result.subscribe(
			(response) => {
				this.loading = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Group was created successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addgroup",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////
}
